import { Card, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FinalReportPlannerVisitProjectFragment } from "../../fragment.generated";
import { FunctionCard } from "./FunctionCard";
import { FinalReportFunctionsCardFunctionFragment } from "./fragments.generated";

type Props = {
    ecologicalFunctions: FinalReportFunctionsCardFunctionFragment[];
    project: FinalReportPlannerVisitProjectFragment;
};

export default function FinalReportFunctionsCard({ ecologicalFunctions, project }: Props) {
    const { t } = useTranslation("project");

    return (
        <Card component={Stack} padding={2} gap={2} variant="outlined">
            <Typography variant="h5">{t("projectReviewVisitV2.finalReportRoute.finalReportFunctionsCard.title")}</Typography>

            {ecologicalFunctions.length === 0 && (
                <Typography>{t("projectReviewVisitV2.finalReportRoute.finalReportFunctionsCard.noFunctions")}</Typography>
            )}

            {ecologicalFunctions.map(ecologicalFunction => (
                <FunctionCard key={ecologicalFunction.id} ecologicalFunction={ecologicalFunction} project={project} />
            ))}
        </Card>
    );
}
